import styled from 'styled-components';
import { tokens } from '@plataforma/components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 190px;
  grid-template-rows: 1fr;
  gap: ${tokens.spacing['xxl-8']};
  width: 864px;
  height: 184px;
  background-color: #f9fbfd;
  border-radius: 4px;
  justify-content: space-between;
  padding: ${tokens.spacing.m} ${tokens.spacing.xxl};
`;

export const Details = styled.div``;

export const BannerImage = styled.div`
  width: 170px;
`;
